var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 17.5,
    r: 3.75,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15c1.5-4.5-1.333-8.9-3-10.733 4.482 4.482 1.148 8.072-2.412 9.91M15.655 5.602c-1.033.197-2.273-.005-3.56-1.272.62-.662 1.496-1.299 2.459-1.508a2.966 2.966 0 011.834.174c.53.226 1.108.633 1.706 1.315-.612.563-1.477 1.109-2.44 1.291z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.405 6.76c-.592.87-1.61 1.604-3.417 1.618-.029-.907.14-1.977.673-2.805.32-.498.774-.914 1.42-1.175.534-.215 1.23-.335 2.136-.276-.035.831-.26 1.828-.812 2.638z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.728 19.044a4.5 4.5 0 01-.862 1.442 4 4 0 10.418-5.423c.301.468.518.994.63 1.558a2.5 2.5 0 11-.186 2.423z",
    fill: "currentColor"
  })));
}
SvgSlots.displayName = 'Slots';
export default SvgSlots;